import React from 'react';
import Popover from 'components/Popover';
import tw from 'twin.macro';
import Button from 'components/Buttons/Button';
import DeleteButton from 'components/Buttons/DeleteButton';
import { CustomFieldDefinitionComponent } from 'containers/UserSettings/NewCustomFieldsSettings/CustomField';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { CustomFieldDefinition } from 'types/customField';

interface Props {
  customFieldDefinition: CustomFieldDefinition;
  onDeleteDefinition: (v: CustomFieldDefinition) => Promise<void>;
  onUpdateDefinition: (v: CustomFieldDefinition) => Promise<void>;
  showEditButtonAlways?: boolean;
}

export function EditCustomFieldDefinition(props: Props) {
  const {
    showEditButtonAlways,
    customFieldDefinition,
    onDeleteDefinition,
    onUpdateDefinition,
  } = props;
  const [edit, setEdit] = React.useState(false);

  const { t } = useTranslation(['common', 'cahierJournal']);
  return (
    <Popover
      as="div"
      portal
      placement={edit ? 'top' : 'bottom'}
      onClickOutside={() => {
        // En faisant ça on empêche le toggle du popover lorsqu'on click sur le color picker qui est en portal
      }}
    >
      <Popover.Button
        aria-label={`Modifier le champ ${customFieldDefinition.name}`}
        icon={PencilIcon}
        css={[
          tw`text-neutral-quiet group-hover:text-neutral-intense invisible group-hover:visible`,
          showEditButtonAlways && tw`visible`,
        ]}
        minimal
        small
      />
      <Popover.Panel
        overflow="visible"
        tw="z-50"
        size={edit ? 'xl' : 'auto'}
        onClose={() => setEdit(false)}
      >
        {edit ? (
          <div tw="p-4 max-h-72 overflow-y-auto">
            <CustomFieldDefinitionComponent
              item={customFieldDefinition}
              inline
              onChange={onUpdateDefinition}
              onDelete={onDeleteDefinition}
              availableTypes={['text', 'select', 'multiselect']}
              definitionTargets={[]}
            />
          </div>
        ) : (
          <>
            <Button
              fill
              alignText="left"
              icon={PencilIcon}
              minimal
              onClick={() => setEdit(true)}
            >
              {t('common:buttons.modify')}
            </Button>
            <DeleteButton
              buttonText={t('common:buttons.delete')}
              withConfirmation
              icon={TrashIcon}
              fill
              minimal
              onClick={() => onDeleteDefinition(customFieldDefinition)}
              popoverText={
                <div>
                  <div tw="mb-2 font-bold">
                    {t(
                      'cahierJournal:seance.modal.confirmDeleteCustomFieldTitle',
                    )}
                  </div>
                  <div tw="text-sm">
                    {t(
                      'cahierJournal:seance.modal.confirmDeleteCustomFieldDetails',
                    )}
                  </div>
                </div>
              }
            >
              {t('common:buttons.delete')}
            </DeleteButton>
          </>
        )}
      </Popover.Panel>
    </Popover>
  );
}
